import {useEffect} from "react";

export const Main = () => {

  useEffect(() => {
    window.location.href = "https://fortworx.com"
  })

  return null;
}
